import React from 'react';
import { Space, Table, Button, Flex } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ProductOptionPicker from 'components/pickers/product-option';
import ImagePicker from 'components/pickers/image/ImagePicker';
import AttributeBottomSheet from './AttributeBottomSheet';

const VariantBlockDesktop = ({ viewModel }) => {
  const {
    options,
    productOptions,
    sortedVariants,
    filteredOptions,
    hasMultipleVariants,
    loadProductOptions,
    applyAttributeSelections,
    onSelectOptionChange,
    onVariantImageChange,
    onGroupImageChange,
    removeOption,
  } = viewModel;

  const rowSpansOpt0 = [];
  const opt0 = filteredOptions[0];

  if (opt0) {
    let i = 0;
    while (i < sortedVariants.length) {
      const val = sortedVariants[i].options?.find((o) => o.id === opt0.id)?.value;
      let count = 1;
      while (i + count < sortedVariants.length) {
        if (sortedVariants[i + count].options?.find((o) => o.id === opt0.id)?.value === val) {
          count += 1;
        } else {
          break;
        }
      }
      for (let j = 0; j < count; j += 1) {
        rowSpansOpt0.push(j === 0 ? count : 0);
      }
      i += count;
    }
  }

  const columns = [
    ...filteredOptions.map((opt, idx) => {
      if (idx === 0) {
        return {
          title: opt.title || 'Thuộc tính 1',
          onCell: (_, rowIndex) => ({ rowSpan: rowSpansOpt0[rowIndex] ?? 1 }),
          width: 250,
          render: (_, record) => {
            const variantOpt = record.options?.find((o) => o.id === opt.id);
            const optDef = productOptions.find((x) => x.id === opt.id);
            const label = optDef?.values?.find((x) => x.id === variantOpt?.value)?.title || variantOpt?.value || '-';
            return (
              <div>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>{label}</div>
                <ImagePicker value={record.image} onChange={(e) => onGroupImageChange(e, opt.id, variantOpt?.value)} />
              </div>
            );
          },
        };
      }

      return {
        title: opt.title || `Thuộc tính ${idx + 1}`,
        render: (_, record) => {
          const variantOpt = record.options?.find((o) => o.id === opt.id);
          const optDef = productOptions.find((x) => x.id === opt.id);
          return optDef?.values?.find((x) => x.id === variantOpt?.value)?.title || variantOpt?.value || '-';
        },
      };
    }),
    ...(filteredOptions.length === 0
      ? [
          {
            title: 'Hình ảnh',
            render: (_, { image, variant_id }) => <ImagePicker value={image} onChange={(e) => onVariantImageChange(e, variant_id)} />,
          },
        ]
      : []),
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      {hasMultipleVariants && (
        <>
          <Space direction='vertical' size={12} style={{ width: '100%' }}>
            {options
              .filter((x) => x.id !== 'default')
              .map((x) => (
                <div key={x.id}>
                  <label>{x.title}</label>
                  <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                    <div style={{ flexGrow: 1 }}>
                      <ProductOptionPicker value={x.values} id={x.id} onChange={onSelectOptionChange} onAddNewValue={loadProductOptions} />
                    </div>
                    <div>
                      <Button onClick={() => removeOption(x.id)} type='text'>
                        <DeleteOutlined />
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
          </Space>
        </>
      )}

      <Flex justify='center'>
        <AttributeBottomSheet
          value={options.filter((x) => x.id !== 'default').map((x) => ({ id: x.id, values: x.values || [] }))}
          productOptions={productOptions}
          onApply={applyAttributeSelections}
          onAttributeCreated={loadProductOptions}
          buttonText='Thêm thuộc tính'
        />
      </Flex>

      {hasMultipleVariants && (
        <Table pagination={false} dataSource={sortedVariants} rowKey={(row) => row?.variant_id || row?.id} columns={columns} />
      )}
    </Space>
  );
};

export default VariantBlockDesktop;
